// Mapbox config is provided by WordPress via wp_localize_script.
// Set values in WP Admin > Options > Mapbox Settings.
const config = (typeof window !== 'undefined' && window.bwtMapConfig) || {};

export const MAPBOX_TOKEN = config.mapboxToken || '';
export const MAPBOX_STYLE = config.mapboxStyle || '';

export const MAPBOX_TILE_URL = (MAPBOX_TOKEN && MAPBOX_STYLE)
  ? `https://api.mapbox.com/styles/v1/${MAPBOX_STYLE}/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_TOKEN}`
  : '';



// WEBPACK FOOTER //
// ./utils/mapbox-config.js